import React from 'react';
import { Box, Typography, Container, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.scss';
import { useLocation } from 'react-router-dom';
import white_footer_divider from './white_footer_divider.svg';
import grey_footer_divider from './grey_footer_divider.svg';

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Box
      className={styles.footerBox}
      data-testid="footer"
      sx={{
        width: '100%',
        backgroundColor: '#460074',
        backgroundImage: `url(${location.pathname === "/analyses" ? grey_footer_divider : white_footer_divider})`,
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        padding: { xs: '20vw 0 40px', md: '140px 0 60px' },
      }}
    >
      <Container maxWidth="xl">
        <Stack spacing={4} sx={{ alignItems: 'center' }}>

          <Typography
            data-testid="footer-brand-name"
            sx={{
              fontSize: '20px',
              color: 'rgba(255, 255, 255, 0.95)',
              fontWeight: 500,
              textAlign: 'center',
              width: '100%'
            }}
          >
            {t('tpoBrand.footer')}
          </Typography>

          <Stack spacing={1} sx={{ alignItems: 'center', width: '100%', maxWidth: '900px' }}>
            <Typography
              data-testid="footer-disclaimer-bold"
              sx={{
                fontSize: '11px',
                fontWeight: 600,
                color: 'rgba(255, 255, 255, 0.8)',
                textAlign: 'center',
                lineHeight: 1.5
              }}
            >
              {t('tpoBrand.disclaimerBold')}
            </Typography>

            <Typography
              data-testid="footer-disclaimer"
              sx={{
                fontSize: '11px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.65)',
                textAlign: 'center',
                lineHeight: 1.5
              }}
            >
              {t('tpoBrand.disclaimer')}
            </Typography>
          </Stack>

        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
